// convert "real-world" aspect ratio to percentage (i.e. used for padding)
// example: 16 / 9 --> 56.25%
export const ratioToPercentage = (ratio: number): number => {
  return 100 / ratio;
};
